import { useWhiteLabelStore } from '@/stores/white-label/WhiteLabelStore';
import type { RouteLocation, NavigationGuardNext } from 'vue-router';
import { sharedRoutes } from '@/shared-routes';
import { collectorRoutePaths } from '@/views/collector-route-paths';
import { ActivationViewType, getActivationService, type ActivationResponse } from '@arcual/lib-app-platform';

export const getRoutePathWithId = (routePath: string, id?: string): string => {
  return id ? routePath.replace(':id', id) : routePath;
};

export const getRedirectRoute = (redirectTo?: string) =>
  redirectTo !== sharedRoutes.LOGIN && redirectTo !== sharedRoutes.LOGOUT ? redirectTo : undefined;

export const checkActivationUnPublished = async (
  _to: RouteLocation,
  _from: RouteLocation,
  next: NavigationGuardNext,
) => {
  const whiteLabelStore = useWhiteLabelStore();

  if (!whiteLabelStore.activation) {
    await whiteLabelStore.setWhiteLabel();
  }

  if (!whiteLabelStore.activation) {
    return next({ path: sharedRoutes.SITE_NOT_FOUND });
  } else if (!whiteLabelStore.activation.isPublished && !whiteLabelStore.activation.publishedAt) {
    return next({ path: sharedRoutes.SITE_NOT_FOUND });
  } else if (!whiteLabelStore.activation.isPublished && whiteLabelStore.activation.publishedAt) {
    return next({ path: collectorRoutePaths.UNPUBLISHED });
  }

  return next();
};

/**
 * Check if the activation is published, if it is redirect to the home page. This is only used on /site-not-found
 */
export const checkActivationPublished = async (_to: RouteLocation, _from: RouteLocation, next: NavigationGuardNext) => {
  const whiteLabelStore = useWhiteLabelStore();

  if (!whiteLabelStore.activation) {
    await whiteLabelStore.setWhiteLabel();
  }

  if (whiteLabelStore.activation) {
    if (whiteLabelStore.activation.isPublished) {
      return next({ path: '/' });
    }
  }

  return next();
};

/**
 * Pulls the activation by subdomain and returns whether its .viewType is that one of Link In Bio
 */
export const isActivationLIB = async (): Promise<boolean> => {
  const subdomain = window.location.hostname.split('.').shift();
  const activation = await getActivationService()
    .getActivationBySubdomain(subdomain as string)
    .then((response: ActivationResponse) => (response.isApiOnly ? null : response))
    .catch(() => null);

  return activation?.viewType === ActivationViewType.LINK_IN_BIO;
}

export const setWhiteLabelForLIB = async () => {
  const whiteLabelStore = useWhiteLabelStore();

  if (
    !whiteLabelStore.activation ||
    !(whiteLabelStore.activation as ActivationResponse | { linkInBioMetadata: { style?: string } }).linkInBioMetadata
  ) {
    await whiteLabelStore.setWhiteLabelForLIB();
  }
};
